import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser, getTransaction } from 'examsbook-react-sdk/actions';
import NoData from '../components/common/Nodata/noData';
import { Paper, Table, TableBody } from '@material-ui/core';
import { TableCell, TableHead, TableRow } from '@material-ui/core';
import { withStyles, createStyles } from '@material-ui/core/styles';
import "../styles/transaction.scss";
import TransactionHistoryMobile from "./transactionHistoryMobile";
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const StyledTableCell = withStyles((theme) =>
    createStyles({
        head: {
            color: theme.palette.common.white,
        }
    }),
)(TableCell);

/**
 * Need to refactor before start.
 */
function Transactions(props) {
    const t = useTranslations();
    const navigate = useNavigate();
    const transaction = useSelector((state) => state.transaction.transactions);
    const dispatch = useDispatch();
    const [ transactionList, setTransactionList ] = useState([]);
    const [ createdDate, setCreatedDate ] = useState();

    function gotoPage() {
        navigate('/my-app/payments/');
    }

    useEffect(() => {
        dispatch(getUser());
        dispatch(getTransaction());
    }, [ dispatch ]);
    useEffect(() => {
        const monthArr = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
        if (transaction && transaction.length > 0) {
            let createdDate = [];
            const transList = transaction.sort((x, y) => (x.transDate < y.transDate) ? 1 : ((x.transDate === y.transDate) ? 0 : -1));
            transList.map(data => {
                const dateObj = new Date(data.created.on);
                createdDate.push({
                    day: ("0" + dateObj.getDate()).slice(-2),
                    month: monthArr[dateObj.getMonth()] + '-' + dateObj.getFullYear()
                });
            });
            setTransactionList(transList);
            setCreatedDate(createdDate);
        }
    }, [ transaction ]);

    function goToDashboard() {
        navigate('/my-app');
    }

    return (
        <div className="transaction-screen">
            <div className="mobile-back-to-test">
                <ArrowBackIcon onClick={goToDashboard}/>
                <span>{t('Transactions')}</span>
            </div>
            <div className="transaction-heading">
                <h4>{t('transactions')}</h4>
            </div>
            <div className="transactionTable">
                <Paper>
                    {
                        transactionList && transactionList.length > 0 ? <Table>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center">{t('DATE')}</StyledTableCell>
                                    <StyledTableCell align="center">{t('PLAN_DETAILS')}</StyledTableCell>
                                    <StyledTableCell align="center">{t('TRANSACTION_ID')}</StyledTableCell>
                                    <StyledTableCell align="center">{t('ORDER_ID')}</StyledTableCell>
                                    <StyledTableCell align="center">{t('AMOUNT')}</StyledTableCell>
                                    <StyledTableCell align="center">{t('STATUS')}</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    transactionList.map((data, index) => (
                                        <TableRow key={index}>
                                            <StyledTableCell>
                                            <span className="date">
                                                {createdDate[index].day} </span>
                                                <span>{createdDate[index].month}</span>
                                            </StyledTableCell>
                                            <StyledTableCell
                                                align="right">{data.plan ? data.plan.name : ''}</StyledTableCell>
                                            <StyledTableCell lign="right">{data.transId}</StyledTableCell>
                                            <StyledTableCell align="right">{data.orderRefNo}</StyledTableCell>
                                            <StyledTableCell align="right"
                                                             className={"amount"}>₹{data.paidAmt}</StyledTableCell>
                                            <StyledTableCell align="right">
                                            <span className={data.status === "SUCCESS" ? 'green-color' : 'red-color'}>
                                                {data.status}
                                            </span>
                                            </StyledTableCell>

                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table> : <div className="noData">
                            <NoData buttonText={t('GET_VIP_NOW')} handleTabChange={() => gotoPage()}
                                    message={t('NO_TRANSACTION_FOUND')}/>
                        </div>
                    }
                </Paper>
                <div className="transaction-mobile">
                    {transactionList && transactionList.length > 0 ?
                        transactionList.map((data, index) => (
                            <TransactionHistoryMobile key={index} t={t} transData={data} date={createdDate[index]}/>
                        )) : <div className="noData">
                            <NoData buttonText={t('GET_VIP_NOW')} handleTabChange={() => gotoPage()}
                                    message={t('NO_TRANSACTION_FOUND')}/>
                        </div>}
                </div>

            </div>
        </div>
    );

}

export default Transactions;
